import React, { useEffect, useReducer, useState } from "react"
import { obterModulosFornecedor } from "../../../services/modulosFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { ModulosFornecedorActionsTypes } from "./modulosFornecedorActions"
import { ModulosFornecedorContext } from "./ModulosFornecedorContext"
import { ModulosFornecedorInicial, modulosFornecedorReducer } from "./modulosFornecedorReducer"

export function ModulosFornecedorContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(modulosFornecedorReducer, ModulosFornecedorInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterModulosFornecedor(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar módulos")
            } else {
                setErroCarregamento(null)
                dispatch({ type: ModulosFornecedorActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar módulos")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    return (
        <ModulosFornecedorContext.Provider value={{ dados, dispatch, erroCarregamento }}>
            <Loading />
            {children}
        </ModulosFornecedorContext.Provider>
    )
}
